module.exports = __webpack_public_path__ + "img/1691024849866-b0dd4ab2-c7e6-49a8-acfe-091f4259cd25.jpeg.09873c8b.webp";